import React from 'react';
import PropTypes from 'prop-types';
import './Publications.css';
import { ArrowRightIcon } from "@heroicons/react/solid";

const Publications = () => (
  <section id="publications" className="min-h-screen text-black bg-black body-font justify-center">
    <div className="lg:w-1024 md:w-full sm:w-full mx-auto flex px-8 py-24 flex-col">
      <div className="flex flex-col w-full mb-8">
        {/*<CodeIcon className="mx-auto inline-block w-10 mb-4" />*/}
        <h1 className="w-full text-2xl sm:text-4xl font-medium title-font mb-4 text-white">
          Publications
        </h1>
        <p className="w-full text-white text-lg tracking-widest">
          Five recent publications. For a full list of publications, visit my&nbsp;
          <a href="https://scholar.google.com/citations?user=iCS-XDYAAAAJ&hl=en"
            target="_blank"
            className="text-amber-400 hover:text-gray-200 underline underline-offset-2">Google Scholar
          </a> profile.
        </p> <br />

        <div className="text-white mt-5 mb-5">
          <h2 className="tracking-widest text-base font-medium text-green-300">2021</h2>
          <a href="https://doi.org/10.1145/3411764.3445770" target="_blank" className="text-lg tracking-widest hover-hover:hover:text-gray-300 text-amber-400 underline underline-offset-2">
            Programmable Smart Home Toolkits Should Better Address Households’ Social Needs
           </a>
          <p className="text-lg tracking-widest">Antti Salovaara, Andrea Bellucci, Andrea Vianello, and Giulio Jacucci</p>
          <p className="text-base py-1 italic">Proceedings of the 2021 CHI Conference on Human Factors in Computing Systems</p>
        </div>

        <div className="text-white mt-5 mb-5">
          <h2 className="tracking-widest text-base font-medium text-green-300">2019</h2>
          <a href="https://doi.org/10.1016/j.ijhcs.2018.09.002" target="_blank" className="text-lg tracking-widest hover-hover:hover:text-gray-300 text-amber-400 underline underline-offset-2">
            Augmenting objects at home through programmable sensor tokens: A design journey
            </a>

          <p className="text-lg tracking-widest">Andrea Bellucci, Andrea Vianello, Yves Florack, Luana Micallef, Giulio Jacucci</p>
          <p className="text-base py-1 italic">International Journal of Human-Computer Studies</p>

        </div>

        <div className="text-white mt-5 mb-5">
          <h2 className="tracking-widest text-base font-medium text-green-300">2018</h2>
          <a href="https://dsq-sds.org/article/view/5934/5144" target="_blank" className="text-lg tracking-widest hover-hover:hover:text-gray-300 text-amber-400 underline underline-offset-2">
            Research in the wild (s): Opportunities, affordances and constraints doing assistive technology field research in underserved areas
            </a>

          <p className="text-lg tracking-widest">Andrea Bellucci, Jason Nolan</p>
          <p className="text-base py-1 italic">Disability Studies Quarterly</p>

        </div>

        <div className="text-white mt-5 mb-5">
          <h2 className="tracking-widest text-base font-medium text-green-300">2018</h2>
          <a href="https://doi.org/10.1145/3230675" target="_blank" className="text-lg tracking-widest hover-hover:hover:text-gray-300 text-amber-400 underline underline-offset-2">
            Augmented experiences in cultural spaces through social participation
            </a>

          <p className="text-lg tracking-widest">Paloma Díaz, Andrea Bellucci, Chien-Wen Yuan, Ignacio Aedo</p>
          <p className="text-base py-1 italic">Journal on Computing and Cultural Heritage (JOCCH)</p>

        </div>

        <div className="text-white mt-5 mb-5">
          <h2 className="tracking-widest text-base font-medium text-green-300">2017</h2>
          <a href="https://doi.org/10.1145/3024969.3024975" target="_blank" className="text-lg tracking-widest hover-hover:hover:text-gray-300 text-amber-400 underline underline-offset-2">
            End-user prototyping of cross-reality environments
            </a>

          <p className="text-lg tracking-widest">Andrea Bellucci, Telmo Zarraonandia, Paloma Díaz, Ignacio Aedo</p>
          <p className="text-base py-1 italic">Proceedings of the Eleventh International Conference on Tangible, Embedded, and Embodied Interaction</p>

        </div>
      </div>

    </div>
  </section>


);

Publications.propTypes = {};

Publications.defaultProps = {};

export default Publications;
